import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-validator"
export default class extends Controller {
  static targets = ["requirement"]
  
  connect() {
    this.requirements = [
      { regex: /.{8,}/, index: 0 },
      { regex: /[a-zA-Z]/, index: 1 },
      { regex: /\d/, index: 2 },
      { regex: /[!@#$%^&*(),.?":{}|<>_\-+=\[\]\\\/~`';]/, index: 3 }
    ]
  }
  
  validate(event) {
    const password = event.target.value
    
    this.requirements.forEach(req => {
      const element = this.requirementTargets[req.index]
      const isMet = req.regex.test(password)
      
      if (isMet) {
        element.classList.remove('requirement-unmet')
        element.classList.add('requirement-met')
        const icon = element.querySelector('i')
        icon.classList.remove('fa-circle')
        icon.classList.add('fa-check-circle')
      } else {
        element.classList.remove('requirement-met')
        element.classList.add('requirement-unmet')
        const icon = element.querySelector('i')
        icon.classList.remove('fa-check-circle')
        icon.classList.add('fa-circle')
      }
    })
  }
}
